import BotaoVoltar from 'portaltransparencia-common/components/BotaoVoltar.react.js';
import { getValueFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import { downloadArquivo } from '../arquivo/Actions.js';
import PageHeader from '../components/PageHeader.react.js';
import * as actions from './Actions.js';
import ContratoDetalheAditivo from './ContratoDetalheAditivo.react.js';
import ContratoDetalheInformacao from './ContratoDetalheInformacao.react.js';

export class ContratoObraDetalhe extends Component {
  static propTypes = {
    aditivos: PropTypes.object.isRequired,
    contrato: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    downloadArquivo: PropTypes.func.isRequired,
    findAditivos: PropTypes.func.isRequired,
    findContratoObra: PropTypes.func.isRequired,
    resetConsulta: PropTypes.func.isRequired
  };

  componentDidMount() {
    const {
      location,
      findContratoObra,
      findAditivos,
      resetConsulta
    } = this.props;

    const entidade = getValueFromUrlSearchParams(location, 'entidade');
    const exercicio = getValueFromUrlSearchParams(location, 'exercicio');
    const contrato = getValueFromUrlSearchParams(location, 'contrato');

    resetConsulta();

    findContratoObra(entidade, exercicio, contrato).then(({ value }) => {
      const entidade = value.entidade;
      const exercicio = value.exercicio;
      const contrato = value.contrato;

      findAditivos(entidade, exercicio, contrato);
    });
  }

  render() {
    const { aditivos, contrato, downloadArquivo } = this.props;

    if (contrato.isEmpty()) {
      return (
        <div>
          <BotaoVoltar />
          Contrato não encontrado!
        </div>
      );
    }

    return (
      <div>
        <PageHeader location={this.props.location} />

        <ContratoDetalheInformacao contrato={contrato} />

        <ContratoDetalheAditivo
          aditivos={aditivos}
          onDownload={downloadArquivo}
          history={this.props.history}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    aditivos: state.contrato.get('aditivos'),
    contrato: state.contrato.get('contrato')
  };
}

const allActions = {
  ...actions,
  downloadArquivo
};

export default connect(mapStateToProps, allActions)(ContratoObraDetalhe);
